<script>
import axios from "axios";

export default {
  name: "BurnRestrictionsView",
  data() {
    return {
      burn: null,
      counties: {
        Prince: true,
        Queens: true,
        Kings: true,
      },
      campfireNotes: "",
      restrictions: null,
      image: null
    };
  },
  mounted() {
    this.getPost();
    this.getRestrictions();
  },
  methods: {
    async getPost() {
      const postData = await axios.post('/burnrestrictions/getFBPost', {campfireNotes: this.campfireNotes, ...this.counties});
      this.burn = postData.data;

      const restrictions = await axios.get('/burnrestrictions/getRestrictions');
      this.restrictions = restrictions.data;
    },
    async getRestrictions() {
      const data  = {
        "appName": "FireRestrictions",
        "featureName": "FireRestrictions",
        "metaVars": {
            "service_id": null,
            "save_location": null
        },
        "queryVars": {
            "service": "FireRestrictions",
            "activity": "FireRestrictions"
        },
        "queryName": "FireRestrictions"
      }

      const response = await axios.post("https://wdf.princeedwardisland.ca/api/workflow", data);
      console.log(response)
      }
  },
  watch: {
    counties: {
      handler() {
        this.getPost();
      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-5">
        <div class="card">
          <div class="card-header">
            Campfire Permitted?
          </div>
          <div class="card-body">
            <form>
              <div class="form-check form-switch col-1">
                <input class="form-check-input" type="checkbox" role="switch" v-model="counties.Prince" id="princeSwitch">
                <label class="form-check-label" for="princeSwitch">Prince</label>
              </div>
              <div class="form-check form-switch col-1">
                <input class="form-check-input" type="checkbox" role="switch" v-model="counties.Queens" id="queensSwitch">
                <label class="form-check-label" for="queensSwitch">Queens</label>
              </div>
              <div class="form-check form-switch col-1">
                <input class="form-check-input" type="checkbox" role="switch" v-model="counties.Kings" id="kingsSwitch">
                <label class="form-check-label" for="kingsSwitch">Kings</label>
              </div>
            </form>
            <div>
              <label for="campfire-notes">Notes</label>
              <input v-model="campfireNotes" id="campfire-notes" type="text"/>
              <button type="button" @click="getPost" class="btn btn-primary">Send</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            Post Text
          </div>
          <div class="card-body">
            <div class="text-start overflow-auto">
              <pre>{{ burn }}</pre>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card">
          <div class="card-header">
            Post Image
          </div>
          <div class="card-body">
<!--            <img src="https://api.fd.3centsmckenna.ca/burnrestrictions/getimg" alt="restrictions" width="500px"/>-->
            <img src="http://localhost:8000/burnrestrictions/getimg" alt="restrictions" width="500px"/>
          </div>
        </div>
          <div class="card">
          <div class="card-header">
            Post Image
          </div>
          <div class="card-body">
<!--            <img src="https://api.fd.3centsmckenna.ca/burnrestrictions/getstoryimg" alt="restrictions" width="500px"/>-->
            <img src="http://localhost:8000/burnrestrictions/getstoryimg" alt="restrictions" width="500px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>